export default {
    install(Vue) {
        // 제목, vue파일 url, state(VIEW-상세보기, WRITE-함수호출시), 보내야할 파라미터)
        Vue.prototype.$popup = function(title, url, state, paramDatas, isBackDrop){
            let modalDatas = { title : title, url: url, state : state, paramDatas, isBackDrop: isBackDrop}
            this.$store.dispatch("modal/setContents", modalDatas);
            
            this.$bvModal.show("popupModal");
        };

        Vue.prototype.$custom_alert = function(title, contents, focusItem, isBackDrop){
            let alertData = { title : title, contents : contents, focusItem : focusItem, isBackDrop: isBackDrop};
            /* eventBus.$emit("alertDatas", alertData); */

            this.$store.dispatch("modal/setContents", alertData);
            this.$bvModal.show("alertModal");
            

        };

        Vue.prototype.$custom_confirm = function(title, contents, isCallbackFunc, isBackDrop){
            let confirmData = { title : title, contents : contents, isCallbackFunc: isCallbackFunc, isBackDrop: isBackDrop};
            /* eventBus.$emit("confirmDatas", confirmData); */
            
            this.$store.dispatch("modal/setContents", confirmData);
            this.$bvModal.show("confirmModal");

        };
    }
}